import script from "./SettingThemeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingThemeComponent.vue?vue&type=script&setup=true&lang=js"

import "./SettingThemeComponent.vue?vue&type=style&index=0&id=d74b9126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d74b9126"]])

export default __exports__